import { Box, Container, Grid, GridItem, Heading, Text, Image, Stack, Button, VStack } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function About() {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(0);

  const images = [
    { src: "/arcade.jpeg", alt: "Arena Bowling Center - Arcade" },
    { src: "/billiard.jpg", alt: "Arena Bowling Center - Billiards" },
    { src: "/food1.png", alt: "Arena Bowling Center - Food" },
    { src: "/ping-pong1.png", alt: "Arena Bowling Center - Ping Pong" },
    { src: "/george.jpeg", alt: "Arena Bowling Center - Bowling" },
    { src: "/burger1.png", alt: "Arena Bowling Center - Burger" },
    { src: "/balls.jpeg", alt: "Arena Bowling Center - Balls" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedImage((prev) => (prev + 1) % images.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <Box id="about" bg="white" color="black" py={{ base: 6, md: 12 }} scrollMarginTop={{ base: 84, md: 110 }}>
      <Container maxW="container.xl">
        <Grid
          templateColumns={{ base: "1fr", md: "1.1fr 1fr" }}
          gap={{ base: 8, md: 12, lg: 16 }}
          alignItems="center"
        >
          {/* Text Section */}
          <GridItem>
            <Stack spacing={5}>
              <Heading size={{ base: "xl", md: "2xl" }}>{t("about_title")}</Heading>
              <Text fontSize={{ base: "md", md: "lg" }} opacity={0.9}>
                {t("about_text_1")}
              </Text>
              <Text fontSize={{ base: "md", md: "lg" }} opacity={0.9}>
                {t("about_text_2")}
              </Text>
              <Text fontSize={{ base: "md", md: "lg" }} opacity={0.9}>
                {t("about_text_3")}
              </Text>
              <Text fontSize={{ base: "md", md: "lg" }} opacity={0.9}>
                {t("about_text_4")}
              </Text>
              <Stack direction={{ base: "column", sm: "row" }} spacing={4} pt={2}>
                <Button
                  onClick={() => {
                    document.getElementById("events")?.scrollIntoView({ behavior: "smooth", block: "start" });
                  }}
                  variant="outline"
                  size="lg"
                  _hover={{ bg: "blackAlpha.200" }}
                >
                  {t("about_events_button")}
                </Button>
                <Button
                  onClick={() => {
                    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
                  }}
                  size="lg"
                  backgroundColor={"black"}
                  color={"white"}
                  _hover={{ backgroundColor: "blackAlpha.800" }}
                >
                  {t("about_contact_button")}
                </Button>
              </Stack>
            </Stack>
          </GridItem>

          {/* Image Gallery */}
          <GridItem>
            <Grid templateColumns="1fr 80px" gap={4} alignItems="start">
              {/* Main Image */}
              <Box
                borderRadius="2xl"
                overflow="hidden"
                boxShadow="0 20px 60px rgba(0,0,0,0.35)"
                position="relative"
                h={{ base: "calc(70px * 4 + 2 * 3px)", sm: "450px", md: "450px", lg: "450px" }}
                minH="0"
                display="flex"
                alignItems="stretch"
              >
                <Image
                  src={images[selectedImage].src}
                  alt={images[selectedImage].alt}
                  w="100%"
                  h="100%"
                  objectFit="cover"
                  transition="all 0.3s ease"
                />
              </Box>

              {/* Thumbnails */}
              <VStack
                spacing={2}
                maxH={{ base: "calc(70px * 4 + 2 * 3px)", sm: "450px", md: "450px", lg: "450px" }}
                minH="0"
                overflowY="auto"
                alignItems="center"
                justifyContent="flex-start"
                sx={{
                  '&::-webkit-scrollbar': {
                    width: '4px',
                  },
                  '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    background: 'blackAlpha.400',
                    borderRadius: '2px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    background: 'blackAlpha.600',
                  },
                }}
              >
                {images.map((img, index) => (
                  <Box
                    key={index}
                    borderRadius="lg"
                    overflow="hidden"
                    cursor="pointer"
                    onClick={() => setSelectedImage(index)}
                    position="relative"
                    border={selectedImage === index ? "2px solid black" : "2px solid transparent"}
                    transition="all 0.2s ease"
                    _hover={{ transform: "scale(1.05)" }}
                    flex="0 0 auto"
                  >
                    <Image
                      src={img.src}
                      alt={img.alt}
                      w="70px"
                      h="70px"
                      objectFit="cover"
                      filter={selectedImage !== index ? "brightness(0.7)" : "none"}
                      transition="all 0.3s ease"
                    />
                    {selectedImage !== index && (
                      <Box
                        position="absolute"
                        top="0"
                        left="0"
                        right="0"
                        bottom="0"
                        bg="blackAlpha.300"
                        transition="all 0.3s ease"
                      />
                    )}
                  </Box>
                ))}
              </VStack>
            </Grid>
          </GridItem>
        </Grid>
      </Container>
    </Box>
  );
}
